export default {
	namespaced: true,
	state: {
		widget: {},
	},

	mutations:{
		/**
		 * [setWidget description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setWidget(state, payload) {
			state.widget = payload
		},
	},
	getters:{
		/**
		 * [widget description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		widget(state) {
			return state.widget
		}
	},
	actions: {

	},

}